import { isAuthenticated } from '../utils/authHelper';
import React from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Paper from '@material-ui/core/Paper'
import Header from './Header'
import VendorPreview from './VendorPreview'
import Snackbar from '@material-ui/core/Snackbar';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import { browserHistory } from 'react-router'
import VendorBasicDetails from './VendorBasicDetails'
import VendorFinancialDetails from './VendorFinancialDetails'
import VendorGstDetails from './VendorGstDetails'



function getSteps() {
  return ['Vendor basic details', 'Gst Details', 'Vendor financial details', 'Preview'];
}
class VendorDetails extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      vendorBasicDetais: undefined,
      vendorFinancialDetails: undefined,
      vendorGstDetails: undefined,
      activeStep: 0,
      state: 'onboard',
      open: true,
      snackText: '',
      snackOpen: false,
    }
  }
  componentDidMount(props) {
    if (this.props.location.state) {
      this.setState({
        vendorBasicDetais: this.props.location.state.vendorBasicDetais,
        vendorGstDetails: this.props.location.state.vendorGstDetails,
        vendorFinancialDetails: {
          ...this.props.location.state.vendorFinancialDetails,
          agreement_expiry_date: typeof this.props.location.state.vendorFinancialDetails.agreement_expiry_date === 'string' ? new Date(this.props.location.state.vendorFinancialDetails.agreement_expiry_date) : this.props.location.state.vendorFinancialDetails.agreement_expiry_date,
          vendor_agreement: String(this.props.location.state.vendorFinancialDetails.vendor_agreement),
          vendor_agreement_file_name: this.props.location.state.vendorFinancialDetails.vendor_agreement_file_name != 'null' ? this.props.location.state.vendorFinancialDetails.vendor_agreement_file_name : '',
          defaultor_amount: this.props.location.state.vendorFinancialDetails.defaultor_amount || 0,
        },
        state: this.props.location.state.state
      })
    }
  }
  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (<VendorBasicDetails data={this.state.vendorBasicDetais}
          handleNext={this.handleNext1.bind(this)}
        />);
      case 1:
        return (<VendorGstDetails data={{ vendorGstDetails: this.state.vendorGstDetails, status: this.state.state }}
          handleNext={this.handleNext2.bind(this)}
          handleBack={this.handleBack1.bind(this)} />)
      case 2:
        return (<VendorFinancialDetails data={{
                ...this.state.vendorFinancialDetails,
                state: this.state.state,
                vendorName: (this.state.vendorBasicDetais.name)?this.state.vendorBasicDetais.name:''
            }}
          handleNext={this.handleNext3.bind(this)}
          handleBack={this.handleBack2.bind(this)} />)

      case 3: return (<VendorPreview data={{
        ...this.state.vendorBasicDetais, ...this.state.vendorGstDetails,
        ...this.state.vendorFinancialDetails, state: this.state.state
      }}
        handleBack={this.handleBack.bind(this)} handleClose={this.handleDialogbox.bind(this)} />)
      default: return
    }

  }
  handleContinue() {
    this.setState({
      activeStep: this.state.activeStep + 1,
    })
  }
  handleNext1 = (value) => {
    if(this.state.activeStep === 0) {
      this.setState({
        vendorBasicDetais: value,
        activeStep: this.state.activeStep + 1
      })
    }
  }
  handleNext2 = (value) => {
    if(this.state.activeStep === 1) {
      this.setState({
        vendorGstDetails: value,
        activeStep: this.state.activeStep + 1
      })
    }
  }
  handleNext3 = (value) => {
    if(this.state.activeStep === 2) {
      this.setState({
        vendorFinancialDetails: value,
        activeStep: this.state.activeStep + 1
      })
    }
  }
  handleBack1 = (value) => {

    this.setState({
      vendorGstDetails: value,
      activeStep: this.state.activeStep - 1
    })
  }
  handleBack2 = (value) => {

    this.setState({
      vendorFinancialDetails: value,
      activeStep: this.state.activeStep - 1
    })
  }

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleDialogbox() {
    this.setState({
      vendorBasicDetais: undefined,
      vendorFinancialDetails: undefined,
      vendorGstDetails: undefined,
      activeStep: 0,
      state: 'onboard',
    })
  }
  handleStepper(index, event) {
    // if (index > this.state.activeStep) {
    //     if (index === 1)
    //         this.handleNext()
    //     if (index === 2)
    //         this.handleContinue()
    // }
    if (index < this.state.activeStep) {
      this.setState({ activeStep: index })
    }
  }
  render() {
    const steps = getSteps()
    const { activeStep } = this.state;
    return (
      <MuiThemeProvider>
        <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <h2 className="zaps-page-title">
              {this.state.state === 'edit' ? 'Edit Vendor' : 'Vendor Onboarding'}
            </h2>
          </div>
          <div className="zaps-page-centered">
            <Paper className="zaps-card zaps-form-card" elevation={0}>
              <Stepper activeStep={activeStep} nonLinear alternativeLabel>
                {steps.map((label, index) => (
                  <Step style={{ cursor: 'pointer' }} key={label}>
                    <StepButton onClick={this.handleStepper.bind(this, index)}>
                      {label}
                    </StepButton>
                  </Step>
                ))}
              </Stepper>
              <div style={{ marginLeft: '68px' }}>
                {this.getStepContent(activeStep)}
              </div>
            </Paper>
          </div>
          <Snackbar
            open={this.state.snackOpen}
            autoHideDuration={1000}
            onClose={this.handleCloseSnack.bind(this)}
            message={this.state.snackText}
          />
        </div>
      </MuiThemeProvider>
    )
  }
}
export default VendorDetails


// WEBPACK FOOTER //
// ./src/components/VendorOnboard.js